
import { alpha } from '@mui/material/styles';
import { gray } from '../getDesignTokens';

export const feedbackCustomizations = {
  MuiAlert: {
    styleOverrides: {
      // Colour comes from the SEVERITY, not a constant.
      //
      // This override used to hard-code orange[100] on `root`, which applies to
      // every severity and every variant. The result: all 104 alerts in the app
      // — and the snackbar, which asks for variant="filled" — rendered the same
      // amber. A failed payment and a saved form were the same colour, and the
      // severity prop was decoration.
      //
      // The palette already defines light/main/dark for error, warning, info
      // and success in both modes (getDesignTokens.js). Nothing new is
      // introduced here; the override simply stops discarding it.
      //
      // The tinted treatment is kept deliberately, including for filled: the
      // snackbar is the app's single place for announcing a failure, and it
      // should not look like a different component from every other alert.
      // `color` is set explicitly because MUI's filled variant would otherwise
      // paint the text white on a light tint.
      root: ({ theme, ownerState }) => {
        const palette = theme.palette[ownerState?.severity] ?? theme.palette.info;

        return {
          borderRadius: 10,
          backgroundColor: alpha(palette.light, 0.22),
          color: theme.palette.text.primary,
          border: `1px solid ${alpha(palette.main, 0.45)}`,
          '& .MuiAlert-icon': {
            color: palette.main,
          },
          ...theme.applyStyles('dark', {
            backgroundColor: alpha(palette.dark, 0.35),
            border: `1px solid ${alpha(palette.dark, 0.6)}`,
            color: theme.palette.text.primary,
          }),
        };
      },
    },
  },
  MuiDialog: {
    styleOverrides: {
      root: ({ theme }) => ({
        '& .MuiDialog-paper': {
          borderRadius: '10px',
          border: '1px solid',
          borderColor: theme.palette.divider,
        },
        '& .MuiDialog-container': {
          paddingLeft: 'var(--sidebar-width, 0px)',
        },
      }),
    },
  },
  MuiLinearProgress: {
    styleOverrides: {
      root: ({ theme }) => ({
        height: 8,
        borderRadius: 8,
        backgroundColor: gray[200],
        ...theme.applyStyles('dark', {
          backgroundColor: gray[800],
        }),
      }),
    },
  },
};
